import React, { useState, useEffect, useRef } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import { withStyles } from '@mui/styles';
import { CircularProgress, FormHelperText, InputLabel, TextField } from '@mui/material';
import get from 'lodash/get';
import { LabelWithToolTip } from 'components';
import { LabelLine } from 'components/InputV2/components';
import { getServiceSet } from './services/ServiceSetServices';


import { useStyles } from './style';

import _ from 'lodash';
const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(1),
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '1.5px 4px',
    },
    '& .MuiInputLabel-formControl': {
      top: '-7px',
      color: '#546e7a',
      fontSize: '12px',
    },
    '& .MuiInputAdornment-root': { color: '#546e7a' },
    '& .MuiAutocomplete-tag': {
      margin: '0 3px',
    },
  },
}))(TextField);

const ServiceSetComponent = ({ errors, control, params, exceptionId = 0, required = false }) => {
  const classes = useStyles();
  const delayedQuery = useRef(_.debounce((v, f) => f(v), 500)).current;
  const [serviceSetList, setServiceSetList] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      setLoading(true);

      const { pagination } = params;
      try {
        const result = await getServiceSet(pagination);
        setLoading(false);
        const data = result.result;

        if (data.length > 0) {
          const list = data
            .filter((val) => val.id !== +exceptionId)
            .map((val) => ({
              name: val?.name || '',
              id: val.id,
            }));

          setServiceSetList(list);
        }
      } catch (error) {
       
        setLoading(false);
      }
    })();

    
  }, []);

  const getList = (val) => {
    if (val.length > 2) {
      const index = serviceSetList.findIndex((item) => item.name.search(val) > -1);

      if (index > -1) {
        return;
      }

      setLoading(true);

      const sendQuery = async () => {
        try {
          const params = { offset: 0, size: 10, searchQuery: val };

          const result = await getServiceSet(params);

          const data = result.result;

          if (data.length > 0) {
            const list = data
              .filter((val) => val.id !== +exceptionId)
              .map((val) => ({
                name: val.name,
                id: val.id,
              }));

            setServiceSetList(list);
          }
        } catch (e) {
          console.log('e :', e);
        
        } finally {
          setLoading(false);
        }
      };

      sendQuery();
    }
  };

  const hasErrorFunc = (name) => {
    if (!required) {
      return false;
    }
    return get(errors, name, false);
  };

  const hasError = hasErrorFunc('serviceSet');

  return (
    <Controller
      name="serviceSet"
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          selectOnFocus
          onChange={(event, newValue) => {
            onChange(newValue);
          }}
          onInputChange={(event, newInputValue) => {
            if (newInputValue) {
              delayedQuery(newInputValue, getList);
            }
          }}
          multiple
          id="serviceSet"
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => option.name}
          options={serviceSetList}
          value={value}
          filterSelectedOptions
          renderInput={(params) => (
            <>
              <InputLabel shrink htmlFor={params?.name} className={classes.label}>
                <LabelLine
                  label={
                    <LabelWithToolTip
                      label="مجموعه سرویس ها"
                      description="مجموعه سرویس‌هایی که سرویس جاری باید عضو آن‌ها باشد را انتخاب کنید."
                    />
                  }
                  required={required}
                />
              </InputLabel>
              <BootstrapInput
                {...params}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && <CircularProgress color="inherit" size={20} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
              {hasError && (
                <FormHelperText id="my-helper-text" className={classes.asterisk}>
                  {errors?.serviceSet?.message}
                </FormHelperText>
              )}
            </>
          )}
        />
      )}
      control={control}
      rules={{
        validate: {
          required: (value) => {
            if (!required) {
              return true;
            }
            return value.length > 0 ? true : 'فیلد مجموعه سرویس الزامی است.';
          },
        },
      }}
      defaultValue={[]}
    />
  );
};

export default ServiceSetComponent;
